import * as React from 'react';
export const lightningBoltSvg = React.forwardRef(function lightningBoltSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.713.281a.75.75 0 0 1 .536.753L9.035 5.75h2.59a1.25 1.25 0 0 1 1.078 1.884L8.146 15.38a.75.75 0 0 1-1.395-.414l.214-4.716h-2.59a1.25 1.25 0 0 1-1.078-1.884L7.854.62a.75.75 0 0 1 .86-.339ZM4.811 8.75H7.75a.75.75 0 0 1 .75.784l-.113 2.48 2.802-4.764H8.25a.75.75 0 0 1-.75-.784l.113-2.48L4.811 8.75Z',
    }),
  );
});
lightningBoltSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var lightningBolt = {
  category: 'icon',
  colorable: true,
  name: 'lightningBolt',
  svg: lightningBoltSvg,
};
